// TODO: Pasar whatsapp link a env.
const WHATSAPP_NUMBER = 524772381607
const whatsappUrl = 'https://api.whatsapp.com/send?phone=' + WHATSAPP_NUMBER

export const useWhatsappMessage = (message: string) => {

    return () => window.open(whatsappUrl+'&text=' + message, '_blank')
}